// Phase 15.2 — Adaptive policy API client.
import { api as client } from "@/api/client";

const BASE = "/api/adaptive-policies";

export const adaptivePolicies = {
    train: (body) => client.post(`${BASE}/train`, body).then((r) => r.data),
    list: (sourceCampaignId) =>
        client.get(BASE, { params: { source_campaign_id: sourceCampaignId } })
            .then((r) => r.data),
    get: (id) => client.get(`${BASE}/${id}`).then((r) => r.data),
    evaluate: (id, body) =>
        client.post(`${BASE}/${id}/evaluate`, body).then((r) => r.data),
};

export default adaptivePolicies;
